"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNSCHEDULED_WORK_WF_DATA_TEST_IDS = void 0;
var UNSCHEDULED_WORK_WF_DATA_TEST_IDS;
(function (UNSCHEDULED_WORK_WF_DATA_TEST_IDS) {
    UNSCHEDULED_WORK_WF_DATA_TEST_IDS["UNSCHEDULED_WORK"] = "UnscheduledWorkWorkflow";
    UNSCHEDULED_WORK_WF_DATA_TEST_IDS["UNSCHEDULED_WORK_SUMMARY"] = "UnscheduledWorkflowSummary";
    UNSCHEDULED_WORK_WF_DATA_TEST_IDS["UNSCHEDULED_WORK_REPORTING_FORM"] = "ReportTravelTimeForm";
    UNSCHEDULED_WORK_WF_DATA_TEST_IDS["TRAVEL_START_TIME"] = "TravelStartTimeInput";
    UNSCHEDULED_WORK_WF_DATA_TEST_IDS["TRAVEL_END_TIME"] = "TravelEndTimeInput";
    UNSCHEDULED_WORK_WF_DATA_TEST_IDS["TRAVEL_START_DATE"] = "TravelStartDatePicker";
    UNSCHEDULED_WORK_WF_DATA_TEST_IDS["TRAVEL_END_DATE"] = "TravelEndDatePicker";
    UNSCHEDULED_WORK_WF_DATA_TEST_IDS["MEAL_BREAK_START_TIME"] = "MealBreakStartTimeInput";
    UNSCHEDULED_WORK_WF_DATA_TEST_IDS["MEAL_BREAK_END_TIME"] = "MealBreakEndTimeInput";
    UNSCHEDULED_WORK_WF_DATA_TEST_IDS["REPORT_TRAVEL_TIME_INPUT_ERROR_BANNER"] = "MessageBannerForInputErrors";
    UNSCHEDULED_WORK_WF_DATA_TEST_IDS["REASON_FOR_TRAVEL_INPUT"] = "ReasonForTravelInput";
    UNSCHEDULED_WORK_WF_DATA_TEST_IDS["MEAL_BREAK_APPLICABLE_VIEW"] = "MealBreakApplicableFormSection";
    UNSCHEDULED_WORK_WF_DATA_TEST_IDS["READ_POLICY"] = "ReadPolicyClickableText";
    UNSCHEDULED_WORK_WF_DATA_TEST_IDS["POLICY_STATEMENT_MODAL"] = "PolicyStatementModal";
    UNSCHEDULED_WORK_WF_DATA_TEST_IDS["ACKNOWLEDGMENT_SECTION"] = "AcknowledgmentSection";
    UNSCHEDULED_WORK_WF_DATA_TEST_IDS["REVIEW_REPORTED_TRAVEL_TIME_CONTAINER"] = "ReviewReportTravelTimeWorkflow";
    UNSCHEDULED_WORK_WF_DATA_TEST_IDS["MEAL_BREAK_IN_REVIEW_PAGE"] = "MealApplicableSectionInReviewPage";
})(UNSCHEDULED_WORK_WF_DATA_TEST_IDS = exports.UNSCHEDULED_WORK_WF_DATA_TEST_IDS || (exports.UNSCHEDULED_WORK_WF_DATA_TEST_IDS = {}));
